<ng-template>
  <unit-selector [reserveScrollbarSpace]="false" [formControl]="formControl" [uiId]="controlId"></unit-selector>
</ng-template>
